import { makeStyles } from "@material-ui/core";

export const TermsAndPoliciesStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    textAlign: "justify",
    position: "relative",
    top: "-50px",
    fontFamily: "Lato",
    fontSize: "12px",
    color: "#747F9D",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  innerContainer: {
    width: "500px",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.up("md")]: {
      width: "500px",
    },
    [theme.breakpoints.down("md")]: {
      width: "350px",
    },
  },
  link: {
    color: "#0344DC",
    textDecoration: "none",
  },
}));
